import { useContext } from 'react';
import { TailwindThemeContext } from '../../contexts/tailwindThemeContext';

const useFontFamily = () => {
  const context = useContext(TailwindThemeContext);
  if (context === undefined) throw new Error('Invalid tailwind theme context.');

  const setFontFamily = (fontFamily: string) => {
    context.setTailwind({
      theme: {
        extend: {
          ...context.tailwind.theme.extend,
          fontFamily: {
            custom: fontFamily,
          },
        },
      },
    });
  };

  return {
    fontFamily: context.tailwind?.theme?.extend?.fontFamily?.custom ?? null,
    setFontFamily,
  };
};

export { useFontFamily };
